<template>
    <div>
        <FormVueSelect append-to-body hide-errors multiple :searchable="false" v-model="selectedValues" max-height="200" class="!tw-h-fit"
            :options="sourcing_types" option-value="value" :label="$t('fields.sourcing_type')" :error="errors.sourcing_type &&
                $t('errors.' + errors.sourcing_type, {
                    field: $t('fields.sourcing_type'),
                })
                ">
            <template v-slot:option="{ option }">
                <p class="tw-p-2 tw-rounded tw-text-xs tw-px-4">{{
                    option.label }}</p>
            </template>
            <template v-slot:selected-option-container="{ params }">
                <div class="vs__selected tw-text-xs tw-py-0 tw-px-2"  @click="removeValue(params.option.value)">{{ params.option.label
                    }}</div>
            </template>
        </FormVueSelect>
    </div>
</template>

<script setup>
import FormVueSelect from "@/components/form/FormVueSelect";
import { computed, ref, watch, inject } from 'vue';
import { useI18n } from "vue-i18n";

const i18n = useI18n();
const updateFilters = inject('update:filters')
const filters = inject('filters')
const sourcing_types = computed(() => [
    {
        label: i18n.t('sourcing.types.new_product'),
        value: 'new_product',
    },
    {
        label: i18n.t('sourcing.types.restock'),
        value: 'restock',
    }
])

const errors = ref({})
const selectedValues = ref(filters.value.sourcing_type || []);
watch(() => selectedValues.value, () => {
    const newFilters = {
        ...filters.value,
        sourcing_type: selectedValues.value,
    }

    updateFilters(newFilters)
})

const removeValue = value => {
    selectedValues.value = selectedValues.value.filter(v => v != value)
}

</script>

<style></style>